import React, { useEffect, useState } from 'react';
import './Admin.scss';
import XLSX from 'xlsx';
import { v4 as uuidv4 } from 'uuid';
import { SheetJSFT } from './Types';
import { Dropdown } from '../../common/DropDown';
import { ADMIN_MASTER_TYPES, TERMS_AND_CONDITIONS_LEVEL_TYPES } from '../../constants';
import { saveTemplateError } from '../../redux/actions/saveTemplateActions';
import { Alert } from '../../common/Alert';
import { ExportAdmindata } from './ExportAdmindata';
import ExportTermsConditionsData from './ExportTermsConditionsData';
import { getTermsConditionsResponse, getTermsCountries } from '../../services/adminMasterServices';
import LoadingIndicator from '../LoadingIndicator';
import CustomSelect from '../../common/CustomSelect/CustomSelect';
import { CommonDropDown } from '../../common/Resusable/CommonDropDown'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { setMasterDataDetails } from '../../redux/actions/masterDataActions'

//Faheem
const ViewTerms = ({
    getSaveTermsMasterResponse,
    saveTermsMasterResponse,
    saveTermsMasterError,
    clearSaveTermsMasterResponse
}) => {

    const [fileName, setFileName] = useState(undefined);
    const [masterType, setMasterType] = useState('');
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [mappedResponse, setMappedResponse] = useState(undefined);
    const [error, setError] = useState(null);
    const [fieldError, setFieldError] = useState('');
    const [fieldCountryError, setFieldCountryError] = useState('');
    const [levelError, setLevelError] = useState('');
    const [pdfData, setPdfData] = useState({
        pdfVal: []
    });
    const [countryData, setCountryData] = useState({
        countryVal: []
    })
    const [isLoading, setIsLoading] = useState(false);
      const masterData = useSelector(state => state?.masterData);
    const dispatch = useDispatch();
    //=============================================================================//

    const handleChange = (files) => {
        setFieldError('')
        setFieldCountryError('')
        var f = files[0]; // FileList object
        var reader = new FileReader();
        // Closure to capture the file information.
        reader.onload = (e) => {
            var binaryData = e.target.result;
            //Converting Binary Data to base 64
            var base64String = window.btoa(binaryData);
            //showing file converted to base64
            setFileName(f?.name);
            setMappedResponse(base64String);

        }
        reader.readAsBinaryString(f);
    }


    const handleUpload = (type) => {
        if (type === "Select") {
            setLevelError('Choose any level before upload');
        } else if (type === 'Global') {
            const payload = {
                "requestId": uuidv4(),
                "termsAndConditions": {
                    "level": "Global",
                    "locationCode": "General",
                    "fileName": fileName,
                    "termsAndConditionsFile": mappedResponse
                }
            }
            mappedResponse != undefined ? getSaveTermsMasterResponse(payload) : setFieldError("Choose any pdf file to upload")
        } else if (type === "Country") {
            const payload = {
                "requestId": uuidv4(),
                "termsAndConditions": {
                    "level": "Country",
                    "locationCode": selectedCountry?.countryCode,
                    "fileName": fileName,
                    "termsAndConditionsFile": mappedResponse
                }
            }
            if (mappedResponse === undefined && (selectedCountry === undefined || selectedCountry === null)) {
                setFieldError("Choose any pdf file to upload")
                setFieldCountryError("Select country")
            } else if (mappedResponse != undefined) {
                if (selectedCountry != null) {
                    getSaveTermsMasterResponse(payload)
                } else {
                    setFieldCountryError("Select country")
                }
            } else if (selectedCountry != null) {
                if (mappedResponse != undefined) {
                    getSaveTermsMasterResponse(payload)
                } else {
                    setFieldError("Choose any pdf file to upload")
                }
            } else {

            }

        } else return;
    }

    const handleAlertClose = () => {
        setError('')
        clearSaveTermsMasterResponse();
        setFileName(undefined);
        setMasterType('Select');
        setMappedResponse([]);
        setTimeout(async () => {
            setIsLoading(true)
            try {
                await getTermsConditionsResponse()
                    .then((response) => {
                        setIsLoading(false)
                        if (response && response.termsAndConditionsList) {
                            return setPdfData({
                                pdfVal: response.termsAndConditionsList
                            })
                        } else {
                            return null
                        }
                    })
                setIsLoading(false)
            } catch (error) {
                console.log(error.message)
                return
            } finally {
                setIsLoading(false)
                setFileName(undefined);
                setMasterType('Select');
                setSelectedCountry('');
                setMappedResponse(undefined);
                setError(null);
                setFieldError('');
                setFieldCountryError('');
            }
            // window.location.reload(true)
        }, 1000);
    }

    const handleAlertCloseSuccess = () => {
        // setError('')
        clearSaveTermsMasterResponse();
        setFileName(undefined);
        setMasterType('Select');
        setMappedResponse([]);
        setTimeout(async () => {
            setIsLoading(true)
            try {
                await getTermsConditionsResponse()
                    .then((response) => {
                        setIsLoading(false)
                        if (response && response.termsAndConditionsList) {
                            return setPdfData({
                                pdfVal: response.termsAndConditionsList
                            })
                        } else {
                            return null
                        }
                    })
                setIsLoading(false)
            } catch (error) {
                console.log(error.message)
                return
            } finally {
                setIsLoading(false)
                setFileName(undefined);
                setMasterType('Select');
                setSelectedCountry('');
                setMappedResponse(undefined);
                setError(null);
                setFieldError('');
                setFieldCountryError('');
            }
            // window.location.reload(true)
        }, 1000);
    }

    useEffect(() => {
        ; (async () => {
            setIsLoading(true)
            try {
                await getTermsConditionsResponse()
                    .then((response) => {
                        setIsLoading(false)
                        if (response && response.termsAndConditionsList) {
                            return setPdfData({
                                pdfVal: response.termsAndConditionsList
                            })
                        } else {
                            return null
                        }
                    })
                setIsLoading(false)
            } catch (error) {
                console.log(error.message)
                return
            } finally {
                setIsLoading(false)
            }
        })();
        ; (async () => {
            setIsLoading(true)
            try {
                // await getTermsCountries()
                //     .then((response) => {
                //         setIsLoading(false)
                //         if (response && response) {
                //             return setCountryData({
                //                 countryVal: response
                //             })
                //         } else {
                //             return null
                //         }
                //     })
                // setIsLoading(false)
                 if (masterData?.termsCountriesMaster && masterData.termsCountriesMaster.length > 0) {
                    setCountryData({
                        countryVal: masterData.termsCountriesMaster
                    })
                    setIsLoading(false)
                } else {
                    
                    await getTermsCountries()
                        .then((response) => {
                            setIsLoading(false)
                            if (response && response) {
                                setCountryData({
                                    countryVal: response
                                })
                                
                                
                                const masterDataPayload = {
                                   
                                    termsCountriesMaster: response
                                }
                                dispatch(setMasterDataDetails(masterDataPayload))
                            } else {
                                return null
                            }
                        })
                    setIsLoading(false)
                }
            } catch (error) {
                console.log(error.message)
                return
            } finally {
                setIsLoading(false)
            }
        })()
    }, [])
    const selectCountryCallback = (val) => {
        setFieldCountryError('');
        setSelectedCountry(val);
    }

    const { t } = useTranslation(['labels'])

    return (
        <>
            {error != null &&
                <div className="master-alert-wrap">
                    <Alert
                        isError={error != null}
                        showAlert={true}
                        message={error != null && error}
                        onAlertClose={handleAlertClose}
                        setTimeout={true}
                    />
                </div>}
            {(saveTermsMasterResponse?.status === "S") &&
                <div className="master-alert-wrap">
                    <Alert
                        isError={false}
                        showAlert={true}
                        message={`Successfully uploaded`}
                        onAlertClose={handleAlertCloseSuccess}
                        setTimeout={true}
                    />
                </div>
            }
            <div className='admin-page__upload-panel'>
                <div className='upload-inner-panel'>
                    <div className='d-flex select-country-container'>
                        <div>
                         <CommonDropDown
                            label="Select level"
                            className={'loose-dimension-unit-dropdown'}
                            value={masterType}
                            options={TERMS_AND_CONDITIONS_LEVEL_TYPES}
                            onChange={(e) => {
                                setFieldError('')
                                setLevelError('')
                                setMasterType(e.target.value)
                            }}     
                        />
                        <span className='search-panel__errormsg'>
                            {levelError != '' ? levelError : ''}
                        </span>
                        </div>

                     {masterType === 'Country' &&
                     <div className='form-item form-group' style={{ height: "45px" }} >

                    <CustomSelect
                                    selectedCountry={selectedCountry?.countryCode}
                                    setSelectedCountry={selectCountryCallback}
                                   
                                    
                                />
                                             <span className='search-panel__errormsg'>
                                               
                                    {fieldCountryError != '' ? fieldCountryError : ''}
                              </span>
                                </div>
                    
                    }
                    </div>


                    {fileName !== undefined ? (
                        <div className='selected-showcase'>
                                <div className="file-info">
                                <img src={require('../../assets/images/documents.svg').default} style={{ height: "24px", width: "24px" }}  />
                                <div className="file-details">
                                    <div className="file-name"> {fileName != undefined ? fileName : ''}</div>
                                    {/* <div className="file-size">{fileSize}</div> */}
                                </div>
                                </div>
                                <img src={require('../../assets/images/delete.svg').default} className='delete-icon' onClick={() => setFileName(undefined)} />
                            
                        </div>
                        ) : (
                        <div >
                        <div className='choose-file-text'>{t('BOOKING.CHOOSE_FILE_BUTTON')}</div>
                        <div className='upload-block'>
                            <input
                                type='file'
                                id='fileButton'
                                accept="application/pdf"
                                onChange={(e) => {
                                    handleChange(e.target.files)
                                    e.target.value = ''
                                }}
                                style={{ display: 'none' }}
                            />
                            <img src={require('../../assets/images/upload.svg').default} style={{ height: "16px", width: "16px" }}  />
                            <div className='d-flex'>
                                <label htmlFor='fileButton' className='click-to-upload-text mb-0'>{t('COMMON.UPLOAD_CLICK')}&nbsp;</label>
                                <span className='drag-drop-text'>{t('COMMON.UPLOAD_DROP')}</span>
                            </div>
                            <div className='drag-drop-text'>{t('ADMIN_MASTER.XLS_PDF')}</div>
                             <span className='search-panel__errormsg '>
                                {fieldError != '' ? fieldError : ''}
                            </span>
                        </div>
                    </div>
                        )}
                    <div className="d-flex justify-content-end">
                        <button
                        className='primary-button upload-button-admin-page'
                        onClick={() => handleUpload(masterType)}
                            >
                        {t('EXCEL.UPLOAD')}
                        </button>	
                    </div>                                    
                </div>

{/* need to add  */}
                {/* {masterType === 'Country' &&
                    <div className='form-group col-md-3'>
                        <div className='form-group'>
                            <label htmlFor='masterType' className='form-item__label'>
                                {masterType}
                            </label>
                            <div className='form-item' style={{ height: "45px" }}>
                                <CustomSelect
                                    selectedCountry={selectedCountry?.countryCode}
                                    setSelectedCountry={selectCountryCallback}
                                />
                                <span className='search-panel__errormsg mt-2'>
                                    {fieldCountryError != '' ? fieldCountryError : ''}
                                </span>
                            </div>
                        </div>
                    </div>} */}
            </div>


            {!isLoading ?
                <div className='admin-page__download-panel'>
                    <label className='heading'>{t('ADMIN_MASTER.TERMS_CON')}</label>
                    <table className="table master-list-table">
                                            <thead>
                                            <tr>
                                                <th className="wide-column">{t('ADMIN_MASTER.COUNTRY')}</th>
                                                <th className="wide-column"> {t('ADMIN_MASTER.FILE_NAME')}</th>
                                                <th></th> 
                                            </tr>
                                            </thead>
                                            <tbody>
                                                {pdfData?.pdfVal?.map((terms, key) => (
                                                <tr>
                                                    <td>{terms?.countryName ? terms?.countryName : ''}</td>
                                                    <td className='file-name-cell'> {terms?.fileName}</td>
                                                    <td>
                                                        <ExportTermsConditionsData
                                                        pdfvalue={terms?.fileName} />
                                                    </td>
                                                </tr>
                                                ))}
                                                </tbody>
                        </table>
                </div> : <LoadingIndicator />}
        </>
    )
}

export default ViewTerms;